import ProfileTextNodes from '@data/i18n/profile.json'

import { lang } from '@lib/constants'
import useBoxOrders from '@lib/hooks/useBoxOrders'
import type { SubscriptionBoxHistories } from '@lib/types/subscription-box'

import Spinner from '@components/Spinner'
import MonthlyBoxOrdersList from '@components/profile/Orders/MonthlyBoxOrdersList'
import AccountLayout from '@components/profile/layout/AccountLayout'

export default function SubscriptionOrders() {
	const { orders, loading: useBoxOrdersLoading } = useBoxOrders()

	// Box state

	if (useBoxOrdersLoading) {
		return (
			<div className="flex flex-col justify-center mx-auto lg:col-span-2">
				<div className="flex justify-center mb-5">
					<Spinner />
				</div>
				<p className="text-center">
					{lang === 'es-es' ? 'Cargando pedidos de suscripción' : 'Loading Subscription Orders'}
				</p>
			</div>
		)
	}

	const subscriptionBoxHistoriesWithProducts = [...((orders || []) as SubscriptionBoxHistories)]
		// FIXME: show 5 orders only
		.slice(0, 5)
		.sort((orderA, orderB) => {
			const orderATime = new Date(orderA.fulfillAt || orderA.createdAt).getTime()
			const orderBTime = new Date(orderB.fulfillAt || orderB.createdAt).getTime()

			if (orderATime < orderBTime) return 1
			else if (orderATime > orderBTime) return -1
			return 0
		})

	return subscriptionBoxHistoriesWithProducts?.length ? (
		<MonthlyBoxOrdersList orders={subscriptionBoxHistoriesWithProducts} />
	) : (
		<span className="p-8">{ProfileTextNodes.orders.noPastSubscriptions}</span>
		// <div className="bg-bbx-pearl-light text-bbx-spark content-center relative col-span-2 m-[20px] rounded-[8px] text-center mt-5 h-fit p-[30px]">
		// 	<svg className="fill-bbx-spark m-auto" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M768-120 517-371l57-57 251 251-57 57Zm-581 0-57-57 290-290-107-107-23 23-44-44v85l-24 24-122-122 24-24h86l-48-48 131-131q17-17 37-23t44-6q24 0 44 8.5t37 25.5L348-699l48 48-24 24 104 104 122-122q-8-13-12.5-30t-4.5-36q0-53 38.5-91.5T711-841q15 0 25.5 3t17.5 8l-85 85 75 75 85-85q5 8 8.5 19.5T841-709q0 53-38.5 91.5T711-579q-18 0-31-2.5t-24-7.5L187-120Z"/></svg>
		// 	<h3 className="mb-6 text-3xl text-center title" style={{ display: 'flex',justifyContent: 'center'}}>
		// 		Under Construction
		// 	</h3>
		// 	<p>We apologize for the inconvenience, but subscription order details are unavailable at this time due to scheduled maintenance. They will be back on May 13th. Please contact customer service at <a className="font-bold" href="mailto:info@birchbox.com">info@birchbox.com</a> if you need further assistance.</p>
		// </div>
	)
}

SubscriptionOrders.Layout = AccountLayout
